import { render } from "./impressum.vue?vue&type=template&id=b0cc1746&scoped=true&ts=true"
import script from "./impressum.vue?vue&type=script&lang=ts"
export * from "./impressum.vue?vue&type=script&lang=ts"

import "./impressum.vue?vue&type=style&index=0&id=b0cc1746&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0cc1746"]])

export default __exports__